import SchoolImage from '../../assets/images/schools.png';
import { useUserName } from '../../contexts/userName';
import { Link, Navigate } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import './style.scss';
import HatSchool from '../../assets/icons/hatSchool.svg';
import usersIcon from '../../assets/images/users.svg';
import BeneficiaryImage from '../../assets/images/admin-opt-4.png';
import WelcomeUser from '../../components/welcomeUser';
import { getSessionHomeRoute, hasActiveSession } from '../../utils/session';

function ProfileView() {
  // STATES //
  const { userName, userRole } = useUserName();
  const sessionActive = hasActiveSession();
  const homeRoute = getSessionHomeRoute(userRole);
  const shouldRedirectToAdminHome = sessionActive && homeRoute !== '/';
  const normalizedUserRole = String(userRole || '')
    .trim()
    .toLowerCase();
  const isMediatorCop = normalizedUserRole === 'mediador cop';
  const isSocialControlMediator =
    normalizedUserRole === 'mediador control social';

  useLayoutEffect(() => {
    if (shouldRedirectToAdminHome) return;

    const root = document.querySelector(':root');
    const firstCard = document.querySelector('.item');
    if (!root || !firstCard) return;

    const cardWidth = firstCard.clientWidth;
    const welcomeWidthDk = cardWidth * 2 + 32;
    root.style.setProperty('--welcome-user-width-dk', `${welcomeWidthDk}px`);
    root.style.setProperty('--welcome-user-width-mb', `${cardWidth}px`);
  }, [shouldRedirectToAdminHome, userName]);

  if (!sessionActive) {
    return <Navigate to='/login' replace />;
  }

  if (shouldRedirectToAdminHome) {
    return <Navigate to={homeRoute} replace />;
  }

  return (
    <>
      <section className='menu'>
        <div className='menu__wrapper wrapper'>
          <div className='wrapper__welcome'>
            <WelcomeUser></WelcomeUser>
          </div>
          <div className='wrapper__content content'>
            <Link to='/escuelas' className='content__item item'>
              <div className='item__def def'>
                <span className='def__text'>Proceso Formativo</span>
                <img src={HatSchool} alt='opt-1-icon' className='def__icon' />
              </div>
              <img src={SchoolImage} alt='opt-1' className='item__img' />
            </Link>
            {!isMediatorCop && !isSocialControlMediator && (
              <Link to={'/registrarEscuelas'} className='content__item item'>
                <div className='item__def def'>
                  <span className='def__text'>
                    Registrar Entidades Aliadas
                  </span>
                  <img src={HatSchool} alt='opt-1-icon' className='def__icon' />
                </div>
                <img src={SchoolImage} alt='opt-1' className='item__img' />
              </Link>
            )}
            <Link to='/calendario' className='content__item item'>
              <div className='item__def def'>
                <span className='def__text'>Calendario</span>
                <img src={usersIcon} alt='opt-1-icon' className='def__icon' />
              </div>
              <img src={BeneficiaryImage} alt='opt-1' className='item__img' />
            </Link>
          </div>
          <Link to='/semaforo' className='wrapper__semaphore-link'>
            <span className='material-symbols-rounded'>traffic</span>
            Semáforo
            <span className='material-symbols-rounded'>arrow_forward</span>
          </Link>
        </div>
      </section>
    </>
  );
}

export { ProfileView };
